// extracted by mini-css-extract-plugin
module.exports = {"outerBox":"FilterBox_outerBox__3h7JG","text":"FilterBox_text__J3wG3","x":"FilterBox_x__39MkM","clearText":"FilterBox_clearText__2VSMb"};